import { de, enUS, fr } from 'date-fns/locale';
import { Locale as DateFNSLocale } from 'date-fns';
import { FeatureFlags } from 'src/application/constants/feature-flags';
import { logger } from 'src/application/logging/logging';

const Languages = ['en', 'de', 'fr'] as const;
export const Namespaces = ['localization', 'dev'] as const;

const disabledLanguages = FeatureFlags.disabledLanguages();
export const SupportedLanguages = Languages.filter((x) => !disabledLanguages.includes(x));

logger().info(`
  Locales:
    - All:        ${Languages}
    - Disabled:   ${disabledLanguages?.length || 'NONE'}
    - Supported:  ${SupportedLanguages}
  `);

export type Language = (typeof Languages)[number];
export type Namespace = (typeof Namespaces)[number];

export const dateLocales: { [key in Language]: DateFNSLocale } = { en: enUS, de: de, fr: fr };

export const fallbackLng: Language = 'en';
export const defaultNS: Namespace = 'localization';
